module.exports = __webpack_public_path__ + "img/ring_g_i_1_1@3x.e53f6e2f.png";